/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Issue_Not_ApprovedInputs */

const en_issue_not_approved = /** @type {(inputs: Issue_Not_ApprovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`not approved yet`)
};

/**
* | output |
* | --- |
* | "not approved yet" |
*
* @param {Issue_Not_ApprovedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const issue_not_approved = /** @type {((inputs?: Issue_Not_ApprovedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issue_Not_ApprovedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_issue_not_approved(inputs)
});